import { render, staticRenderFns } from "./LottoSim.vue?vue&type=template&id=0d320faa&scoped=true&lang=pug"
import script from "./LottoSim.vue?vue&type=script&lang=js"
export * from "./LottoSim.vue?vue&type=script&lang=js"
import style0 from "./LottoSim.vue?vue&type=style&index=0&id=0d320faa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d320faa",
  null
  
)

export default component.exports